export default {
    data() {
        return {};
    },
    methods: {
        getValueForField(field) {
            let matchingField = this.headerOptionsAndValues.find((f) => f.LabelText === field);

            if (matchingField) {
                if (matchingField.Value) {
                    return matchingField.Value;
                }

            }

            return '';
        },
        getRowsForHeaders(data) {
            let rows = [];

            let inputs = Object.entries(data);

            for (let i = 0; i < inputs.length; i += 2) {
                let row = [];

                if (inputs[i][1]) {
                    row.push(`${inputs[i][1]}: ${this.getValueForField(inputs[i][1])}`);
                }

                if (i + 1 < inputs.length && inputs[i + 1][1]) {
                    row.push(`${inputs[i + 1][1]}: ${this.getValueForField(inputs[i + 1][1])}`);
                }

                if (row.length) {
                    rows.push(row);
                }
            }

            return rows;
        },
    }
};
